import $ from 'jquery'
import manager from '../manager'
// import Hammer from 'hammerjs'
import {activeAllLazyImageDom} from '@/view/lib/lazy'

manager.add('carousel', {
	created(speed, type = 'slide') {
		if (speed < 1) speed = 1
		var len = $(this.dom).find(".imgs").children().not(".mock").length
		if (!len) return
		activeAllLazyImageDom(this.dom)
		var box = $(this.dom)
		if (type == "slide") {
			if (!$(this.dom).find(".imgs .mock").length) {
				var mock = $($(this.dom).find(".imgs").children().get(len - 1)).clone()
				mock.addClass("mock")
				$(this.dom).find(".imgs").prepend(mock)
			}
		}
		var i = 0
		var onchange = () => {
			var h = Math.max.apply(Math.max, $(this.dom).find(".imgs img").map(function() { return $(this).height() }).get())
			var w = $(box).width()
			$(this.dom).find(".imgs").height(h)
			$(this.dom).find(".imgs img").width(w)
			$(this.dom).find(".item").removeClass("active")
			$(this.dom).find(".item").eq(i).addClass("active")
			if (len < 2) return
			if (type == "slide") {
				$(this.dom).find(".imgs").css("margin-left", -w * (i + 1) + "px")
				if (i == len - 1) {
					setTimeout(() => {
						$(this.dom).find(".imgs").addClass("reset")
						$(this.dom).find(".imgs").css("margin-left", "0px")
					}, 500)
				}
				if (i == 0) {
					$(this.dom).find(".imgs").removeClass("reset")
				}
			} else {
				$(this.dom).find(".imgs img").addClass('hide')
				$(this.dom).find(".imgs img").eq(i).removeClass('hide')
			}
		}
		var resetTimer = () => {
			clearInterval(this.timer)
			this.timer = setInterval(() => {
				i = i < len - 1 ? i + 1 : 0
				onchange()
			}, speed * 1000)
		}
		$(this.dom).find(".arrow-left").on("click", () => {
			i = i < 0 ? len - 1 : i - 1
			onchange()
			resetTimer()
		})
		$(this.dom).find(".arrow-right").on("click", () => {
			i = i < len - 1 ? i + 1 : 0
			onchange()
			resetTimer()
		})
		setTimeout(()=>{
			onchange()
		},0)
		resetTimer()
	},
	destroyed() {
		if (this.timer) {
			clearInterval(this.timer)
		}
		$(this.dom).find(".imgs").css("margin-left", "0px")
	}
})

// manager.add('carousel.touch', {
// 	created(col,speed) {
// 		this.index=0
// 		this.box=$(this.dom).find("ul.items")
// 		this.items=this.box.find("li")
// 		this.len=this.items.length
// 		this.pagenum=this.len
// 		this.lock=false
// 		this.col=col||1
// 		this.speed=speed||3
// 		this.mock()
// 		$(this.dom).find(".arrow-left").on("click", () => {
// 			if(this.lock)return
// 			this.index--
// 			this.switch()
// 		})
// 		$(this.dom).find(".arrow-right").on("click", () => {
// 			if(this.lock)return
// 			this.index++
// 			this.switch()
// 		})
// 		this.hammer = new Hammer(this.box[0])
// 		this.panOffset=0
// 		this.hammer.on('pan',e=>{
// 			this.panOffset=e.deltaX/this.box.width()
// 			this.box.css({"transform":`translateX(${-100*(this.index+1)+this.panOffset*100}%)`,"transition":""})
// 		})
// 		this.hammer.on('panend',()=>{
// 			this.index=this.index-Math.round(this.panOffset)
// 			this.switch()
// 			this.panOffset=0
// 		})
// 		this.hammer.on('swipeleft',()=>{
// 			if(this.lock)return
// 			this.index++
// 			this.switch()
// 		})
// 		this.hammer.on('swiperight',()=>{
// 			if(this.lock)return
// 			this.index--
// 			this.switch()
// 		})
// 	},
// 	mock(){
// 		this.box.remove(".virtual")
// 		for(let i=0;i<this.col-1;i++){
// 			for(let j=0;j<this.len;j++){
// 				this.box.append(this.items.eq(j).clone().addClass("virtual"))
// 			}
// 		}
// 		this.box.append(this.items.slice(0,this.col).clone().addClass("virtual"))
// 		this.box.prepend(this.items.slice(this.len-this.col,this.len).clone().addClass("virtual"))
// 		this.box.css({"transform":'translateX(-100%)',"transition":"none"})
// 		manager.active(this.box[0])
// 	},
// 	switch(){	
// 		this.lock=true
// 		if(this.index<0){
// 			this.box.css({"transform":`translateX(${-100*(this.index+1)}%)`,"transition":""})
// 			this.index=this.pagenum-1
// 		}else if(this.index>this.pagenum-1){
// 			this.box.css({"transform":`translateX(${-100*(this.index+1)}%)`,"transition":""})
// 			this.index=0
// 		}else{
// 			this.box.css({"transform":`translateX(${-100*(this.index+1)}%)`,"transition":""})
// 		}
// 		$(this.box).one('transitionend',()=>{
// 			this.box.css({"transform":`translateX(${-100*(this.index+1)}%)`,"transition":"none"})
// 			this.lock=false
// 		})
// 	},
// 	destroyed() {
// 		this.hammer.destroy()
// 	}
// })